/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ plan: NonNullable<unknown> }} Partner_Manage_Plan_Upgrade_TitleInputs */



/**
* | output |
* | --- |
* | "Upgrade to {plan}?" |
*
* @param {Partner_Manage_Plan_Upgrade_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_manage_plan_upgrade_title = /** @type {((inputs: Partner_Manage_Plan_Upgrade_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Manage_Plan_Upgrade_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Auf ${i?.plan} upgraden?`)
	return /** @type {LocalizedString} */ (`Upgrade to ${i?.plan}?`)
});